import React, { useMemo } from 'react';

import { useDisableScroll } from './hooks/useDisableScroll.hook';
import { WritableKeys } from 'ts-toolbelt/out/Object/WritableKeys';
import { RenderHtmlElement } from './RenderHtmlElement.component';
import {
  cloneNode,
  copyNodeComputedStyle,
  findScrollableParents,
  getBoundingClientFixedPosition,
} from './domUtils';


const keys = <T extends object>(obj: T): Array<keyof T> => Object.keys(obj) as (keyof T)[];

type WritableCssStyleDeclaration = Partial<Omit<Pick<CSSStyleDeclaration, WritableKeys<CSSStyleDeclaration>>, 'getPropertyPriority' | 'getPropertyValue' | 'item' | 'removeProperty' | 'setProperty'>>
const applyStyles = (element: HTMLElement, styles: WritableCssStyleDeclaration) => {
  keys(styles).forEach(key => {
    (element.style as any)[key] = String(styles[key]);
  });

  return element;
};


type DetailPopupClonedRootProps = {
  popupRootSelector: string;
}

export const DetailPopupClonedRoot = ({
  popupRootSelector,
}: DetailPopupClonedRootProps) => {
  const popupRoot = useMemo(() => document.querySelector(popupRootSelector), [popupRootSelector]) as HTMLElement;
  const scrollableParents = useMemo(() => popupRoot ? findScrollableParents(popupRoot) : [], [popupRoot]);

  const clonedRoot = useMemo(() => {
    if (!popupRoot) {
      return null;
    }

    return applyStyles(
      copyNodeComputedStyle(popupRoot, cloneNode(popupRoot)),
      getBoundingClientFixedPosition(popupRoot)
    );
  }, [popupRoot]);

  useDisableScroll(scrollableParents);

  return (
    <RenderHtmlElement element={clonedRoot}/>
  );
};
